import React, { ReactElement } from "react";
import { TableColumn } from "../../Table";
import TableCell from "../../TableCell";
import { formatPercentage } from "../../../utils/Utils";

export const cellForColumn = (item: any, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
    switch (column.propertyPath) {

        case "studentDisplayName":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {item.studentDisplayName}
                </span>
                <span className="cdb-table__extra-detail">
                    {item.studentUserPrincipalName}
                </span>
            </TableCell>;

        case "teacherDisplayName":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {item.teacherDisplayName}
                </span>
                <span className="cdb-table__extra-detail">
                    {item.teacherUserPrincipalName}
                </span>
            </TableCell>;

        case "subjectName":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {item.subjectName}
                </span>
                <span className="cdb-table__extra-detail">
                    {item.subjectCode}
                </span>
            </TableCell>;

        case "classesWithAssignmentsPercentage":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {formatPercentage(item.classesWithAssignmentsPercentage)}
                </span>
                <span className="cdb-table__extra-detail cdb-table__extra-detail--ellipsis">
                    {item.classesWithAssignmentsCount} out of {item.classesTotal} classes have an assignment
                </span>
            </TableCell>;

        case "submissionsSubmittedBeforeDueDatePercentage":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {formatPercentage(item.submissionsSubmittedBeforeDueDatePercentage)}
                </span>
                <span className="cdb-table__extra-detail cdb-table__extra-detail--ellipsis">
                    {item.submissionsSubmittedBeforeDueDateCount}
                </span>
            </TableCell>;

        case "submissionsSubmittedAfterDueDatePercentage":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {formatPercentage(item.submissionsSubmittedAfterDueDatePercentage)}
                </span>
                <span className="cdb-table__extra-detail cdb-table__extra-detail--ellipsis">
                    {item.submissionsSubmittedAfterDueDateCount}
                </span>
            </TableCell>;

        case "submissionsNotCompletedPercentage":
            return <TableCell key={columnIndex} flex={column.flex}>
                <span>
                    {formatPercentage(item.submissionsNotCompletedPercentage)}
                </span>
                <span className="cdb-table__extra-detail cdb-table__extra-detail--ellipsis">
                    {item.submissionsNotCompletedCount}
                </span>
            </TableCell>;

        default:
            return undefined;
    }
};